import { createContext } from 'react'

interface UserContext {
  user?: firebase.User | null
  initialising?: boolean
}

export default createContext<UserContext>({
  user: undefined
})